export default __webpack_public_path__ + "static/media/Chery-Range-Service.dd9ae49c.webp";